<div class="snack-bar">
  <mat-icon class="success-icon">check_circle</mat-icon>
  <div> {{data?.message}} </div>
  <mat-icon class="snack-bar-close" (click)="snackBarRef.dismiss()">close</mat-icon>
</div>
